<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_6"></a><a id="page_7"></a>Preface</h2>
<p class="indent">There once was a custom among novelists, a sort of gentle address, a polite bow before the raising of the curtain. Though much honored still, its practice is sadly neglected. The curtain has hardened this past century into a wall. The human voice of the storyteller is supplanted by a call for greater Realism, as though some Reality exists to be measured outside of ourselves. Measured by whom? According to what yardstick?</p>
<p class="indent">And so this custom has faded from the pages of novels. I think it a custom worth reviving. It is a civil custom, and these are uncivil times. A patient custom for a hurried age. A warm hearth and a welcoming hand extended on a cold, cheerless night.</p>
<p class="indent">Allow me, therefore, my conceit, Gentle Reader, to proffer you these words of welcome. The hearth is blazing. There is a kettle on the fire, and the story waits upon your good company. Without, the wind howls and passions rage. It may be, before we are finished, you and I, that passions will rage within as well. But for now, relax, sip your cup of tea and listen to my tale. And when I am through, we may go our separate ways into the world. Perhaps to meet again sometime, before another hearth, over another tale.</p>
<p class="attribute">—D. Holland<br/>February 2000</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface.vue?034ddc27